export const BILL_TYPE = Object.freeze({
  mobile: 0,
  internet: 1,
  vehicle: 2,
  house: 3,
  utility: 4,
});

export const TRANSACTION_TYPE = Object.freeze({
  card2card: 0,
  music: 1,
  vehicle: 2,
});
